import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { Trainers } from './pages/trainers/trainers';
import { Trainees } from './pages/trainees/trainees';
import { Managers } from './pages/managers/managers';
import { Branches } from './pages/branches/branches';
import { Tournaments } from './pages/tournaments/tournaments';
import { TournamentDetailPage } from './pages/tournament-detail/tournament-detail';
import { UsersPage } from './pages/users/users';
import { Sessions } from './pages/sessions/sessions';
import { Sports } from './pages/sports/sports';
import { ActivityLog } from './pages/activity-log/activity-log';
import { SettingsPage } from './pages/settings/settings';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/trainees', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'managers', component: Managers, canActivate: [authGuard] },
  { path: 'trainers', component: Trainers, canActivate: [authGuard] },
  { path: 'trainees', component: Trainees, canActivate: [authGuard] },
  { path: 'users', component: UsersPage, canActivate: [authGuard] },
  { path: 'branches', component: Branches, canActivate: [authGuard] },
  { path: 'sports', component: Sports, canActivate: [authGuard] },
  { path: 'tournaments', component: Tournaments, canActivate: [authGuard] },
  { path: 'tournaments/:id', component: TournamentDetailPage, canActivate: [authGuard] },
  { path: 'sessions', component: Sessions, canActivate: [authGuard] },
  { path: 'activity-log', component: ActivityLog, canActivate: [authGuard] },
  { path: 'settings', component: SettingsPage, canActivate: [authGuard] },
  { path: '**', redirectTo: '/trainees' }
];
